import { Container } from 'components/container'
import { Bar, Buttons, LG, ObservedPoint } from './styled'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { AmazonStore } from './icons/download-amazon-store'
import { GooglePlay } from './icons/download-google-play'
import { AppStore } from './icons/download-app-store'

export const DownloadBar = () => {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref)

  return (
    <>
      <ObservedPoint ref={ref} />
      <Bar $isOpaque={isInView}>
        <Container>
          <p>
            Смотрите только <br />в приложении Votvot
          </p>
          <Buttons>
            <a
              href="https://apps.apple.com/ru/app/votvot/id1667840613"
              target="_blank"
            >
              <AppStore />
            </a>
            <a
              href="https://www.amazon.com/gp/product/B0BZ8589PT"
              target="_blank"
            >
              <AmazonStore />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.twentyfouri.tvbridge.rferl"
              target="_blank"
            >
              <GooglePlay />
            </a>
          </Buttons>
          <LG>Также на смарт-тв Samsung и LG</LG>
        </Container>
      </Bar>
    </>
  )
}
